import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoggedInGuard } from "../guards/logged-in-guard.service";
import { AdminComponent } from "./admin/admin.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { PageNotfoundComponent } from "../page-notfound/page-notfound.component";
import { PoDetailsComponent } from "./po-details/po-details.component";
import { HelpComponent } from "./admin/help/help.component";
import { ProfileUpdateComponent } from "./profile-update/profile-update.component";
import { WorkingCapitalComponent } from "./working-capital/working-capital.component";
import { CollectiveBuyingComponent } from "./collective-buying/collective-buying.component";
import { PendingApprovalComponent } from "./pending-approval/pending-approval.component";
import { TicketsComponent } from "./tickets/tickets.component";
import { NotificationComponent } from "./notification/notification.component";
import { EngageRequestComponent } from "./engage-request/engage-request.component";
import { ProcureComponent } from "./procure/procure.component";
import { ProcureAddQuoteComponent } from "./procure/add-quote/add-quote.component";
import { ProcureEditQuoteComponent } from "./procure/edit-quote/edit-quote.component";
import { ProcureViewOrderComponent } from "./procure/view-order/view-order.component";
import { EditRmsBidComponent } from "./procure/edit-rms-bid/edit-rms-bid.component";
import { InspectionComponent } from "./inspection/inspection.component";

const routes: Routes = [
  {
    path: "",
    component: AdminComponent,
    canActivate: [LoggedInGuard],
    children: [
      {
        path: "",
        canActivateChild: [LoggedInGuard],
        children: [
          {
            path: "dashboard",
            component: DashboardComponent,
          },

          //:OLD COMPONENT. NOT USED ANYMORE. DELETE
          {
            path: "purchase-orders",
            loadChildren: () =>
              import("./purchase-order/purchase-order.module").then(
                (m) => m.PurchaseOrderModule
              ),
          },
          {
            path: "dispatches",
            loadChildren: () =>
              import("./dispatch/dispatch.module").then(
                (m) => m.DispatchModule
              ),
          },
          {
            path: "invoices",
            loadChildren: () =>
              import("./invoice/invoice.module").then((m) => m.InvoiceModule),
          },
          {
            path: "shipments",
            loadChildren: () =>
              import("./shipments/shipments.module").then(
                (m) => m.ShipmentsModule
              ),
          },
          {
            path: "quotes",
            loadChildren: () =>
              import("./partner-quotes/quotes.module").then(
                (m) => m.QuotesModule
              ),
          },
          {
            path: "supplier-invoices",
            loadChildren: () =>
              import("./supplier-invoices/supplier-invoices.module").then(
                (m) => m.SupplierInvoicesModule
              ),
          },
          {
            path: "rfq",
            loadChildren: () =>
              import("./biddings/biddings.module").then(
                (m) => m.BiddingsModule
              ),
          },
          {
            path: "supplier-profile",
            loadChildren: () =>
              import("./supplier-profile/supplier-profile.module").then(
                (m) => m.SupplierProfileModule
              ),
          },
          {
            path: "working-capital",
            component: WorkingCapitalComponent,
          },
          {
            path: "collective-buying",
            component: CollectiveBuyingComponent,
          },

          {
            path: "purchase-order/:id",
            component: PoDetailsComponent,
          },
          {
            path: "update-profile",
            component: ProfileUpdateComponent,
          },
          {
            path: "help",
            component: HelpComponent,
          },
          {
            path: "",
            redirectTo: "dashboard",
            pathMatch: "full",
          },
          {
            path: "pending-approval",
            component: PendingApprovalComponent,
          },
          {
            path: "inspection",
            component: InspectionComponent,
          },
          {
            path: "tickets",
            component: TicketsComponent,
          },
          {
            path: "notification",
            component: NotificationComponent,
          },
          {
            path: "engage-request",
            component: EngageRequestComponent,
          },
          {
            path: "procure",
            component: ProcureComponent,
          },
          {
            path: "procure/add-quote",
            component: ProcureAddQuoteComponent,
          },
          {
            path: "procure/edit-quote/:id",
            component: ProcureEditQuoteComponent,
          },
          {
            path: "procure/view-order/:id",
            component: ProcureViewOrderComponent,
          },
          {
            path: "procure/edit-bid/:id/:quoteId/:length",
            component: EditRmsBidComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
